export const wrongPageTheme = {
  icons: {
    notFound: {
      bgCircle: 'palette.tertiary.20',
      dot: 'palette.primary.20',
      search: 'palette.tertiary.70',
      searchCircle: 'palette.surface.5',

      rightBar: 'palette.primary.95',
      topRightBar: 'palette.primary.70',

      barDot: 'palette.primary.99',

      leftBar: 'palette.primary.70',
      topLeftBar: 'palette.primary.50',
    },
    permissionDenied: {
      barDot: 'palette.primary.99',
      bg: 'palette.primary.70',
      bgCircle: 'palette.tertiary.20',
      dot: 'palette.primary.20',
      lock: 'palette.surface.5',
      lockDot: 'palette.primary.99',
      topBar: 'palette.primary.50',
    },
    somethingWrong: {
      barDot: 'palette.primary.99',
      bg: 'palette.primary.70',
      bgCircle: 'palette.tertiary.20',
      dot: 'palette.primary.20',
      questionMark: 'palette.primary.90',
      topBar: 'palette.primary.50',
    },
  },
  message: 'palette.tertiary.40',
  title: 'palette.tertiary.90',
};
